// this method removes "W " or "M " at the beginning of the product name, which are used by the client to distinct between products for men and women
export const trimProductNameGenderPrefix = (name?: string) => {
  if (!name) {
    return ''
  }
  return name.replace(/^(W |M )/, '')
}
